/**
 * site-animations.js — Elegant scroll-reveal + page transitions.
 * Luxe personality: slow, deliberate, barely-there.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // ─── Scroll-reveal via IntersectionObserver ───
  function initReveal() {
    var threshold = 0.12;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: threshold, rootMargin: '0px 0px -40px 0px' },
    );

    // Explicit data-reveal elements
    document.querySelectorAll('[data-reveal], [data-reveal-stagger]').forEach(function (el) {
      observer.observe(el);
    });

    // Auto-reveal sections (CSS hides them from first paint; JS reveals on scroll).
    // Observe ALL visual children (some shopify-sections have mobile + desktop variants as siblings).
    document
      .querySelectorAll('main.content-for-layout > .shopify-section:not(:first-child)')
      .forEach(function (section) {
        section
          .querySelectorAll(':scope > section, :scope > header, :scope > div, :scope > article')
          .forEach(function (inner) {
            observer.observe(inner);
          });
      });
  }

  // ─── Page transitions (fade to white on navigate) ───
  function initPageTransitions() {
    var overlay = document.createElement('div');
    overlay.className = 'page-transition-overlay';
    overlay.innerHTML = '&nbsp;';
    document.body.appendChild(overlay);

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (!link) return;

      var href = link.getAttribute('href');
      if (!href) return;
      if (
        href.startsWith('#') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:') ||
        href.startsWith('javascript')
      )
        return;
      if (link.target === '_blank') return;
      if (link.hostname && link.hostname !== window.location.hostname) return;
      if (link.hasAttribute('data-no-transition')) return;
      if (href.includes('/cart/') && (href.includes('/add') || href.includes('/change'))) return;

      e.preventDefault();
      overlay.classList.add('is-active');

      var navigated = false;
      function go() {
        if (navigated) return;
        navigated = true;
        window.location.href = href;
      }
      overlay.addEventListener('transitionend', go, { once: true });
      setTimeout(go, 500);
    });

    // Browser back/forward: clear overlay if bfcache restores page
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) overlay.classList.remove('is-active');
    });
  }

  // ─── Navbar scroll detection ───
  function initNavbarScroll() {
    var nav = document.querySelector('.nav_fixed-2');
    if (!nav) return;

    var scrolled = false;
    function check() {
      var isScrolled = window.scrollY > 40;
      if (isScrolled !== scrolled) {
        scrolled = isScrolled;
        nav.classList.toggle('is-scrolled', scrolled);
      }
    }

    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  // ─── Hero entrance via GSAP (reliable, no CSS transition bugs) ───
  function initHeroEntrance() {
    if (typeof gsap === 'undefined') return;

    document.querySelectorAll('[data-hero-entrance]').forEach(function (container) {
      var items = container.querySelectorAll('[data-hero-item]');
      if (!items.length) return;
      gsap.set(items, { opacity: 0, y: 18 });
      gsap.to(items, {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: 'power2.out',
        stagger: 0.15,
        delay: 0.2,
      });
    });

    document.querySelectorAll('[data-pdp-hero-entrance]').forEach(function (container) {
      var gallery = container.querySelector('.pdp-gallery-static');
      var info = container.querySelector('.product-information');
      if (gallery) {
        gsap.set(gallery, { opacity: 0, x: -20 });
        gsap.to(gallery, { opacity: 1, x: 0, duration: 1, ease: 'power2.out', delay: 0.2 });
      }
      if (info) {
        gsap.set(info, { opacity: 0, x: 20 });
        gsap.to(info, { opacity: 1, x: 0, duration: 1, ease: 'power2.out', delay: 0.35 });
      }
    });
  }

  // ─── Init ───
  function init() {
    initReveal();
    initPageTransitions();
    initNavbarScroll();
    initHeroEntrance();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
